import React from "react";
import { Box, Button, Heading, Text, Tip } from "grommet";
import { InstObject } from "../config/types";
import {
    selectedInstsKeptR,
    selectedInstsR,
} from "../recoils/selectedInsts";
import { useRecoilState } from "recoil";
import { useNavigate } from "react-router-dom";
import { ImArrowRight } from "react-icons/im";
import { Close } from "grommet-icons";
import useToc from "../hooks/useToc";
import { libraryTocs } from "../recoils/library";

const InstSelectBox = (props: any) => {

    
    // state from recoil
    const [selectedInsts, setSelectedInsts] =
        useRecoilState(selectedInstsR);
    const [selectedInstsKept, setSelectedInstsKept] =
        useRecoilState(selectedInstsKeptR);
    const [libraryTocsData, setLibraryTocsData] = useRecoilState(libraryTocs)
    const [calledTocsInstname, setCalledTocsInstname] = React.useState<any>([])

    React.useEffect(()=>{
        console.log("libraryTocData length", libraryTocsData.length)
        let tocs:any = []
        const getTocsInfo = async(iname:string) => {
            const res = await useToc.getTocSearch([iname]);
            console.log("getTocsInfo", res)
            if(res) return res.tocs
        }
        selectedInstsKept.map((inst:InstObject)=>{
            let inst_name = inst.primaryname
            // check if toc is already called
            let called = false
            calledTocsInstname.map((iname:string)=>{
                if(inst_name.includes(iname)){
                    called = true
                }
            })
            if(!called){
                getTocsInfo(inst_name).then((res)=>{
                    console.log("getTocsInfo", res)
                    // result length
                    const n_res = res.length
                    let n_res_count = 0
                    // check if toc is already in tocs
                    res.map((toc:any)=>{
                        let index = tocs.findIndex((p:any)=>p.toc_id === toc.toc_id)
                        n_res_count += 1
                        if(index < 0){
                            tocs.push(toc)
                        }
                        if(n_res_count === n_res){
                            console.log("tocs", tocs)
                            setLibraryTocsData([...libraryTocsData, ...tocs])
                        }
                    })
                })
            }
        })
    },[selectedInstsKept])

    let navigate = useNavigate();

    const gotoInstPage = () => {
        if (selectedInsts.length > 0) {
            let n_inst = selectedInsts.length;
            console.log("gotoInstPage", selectedInsts);
            let id_list = selectedInsts.map((inst) => inst.inst_id);
            let id_string = id_list.join("&");
            navigate("/inst#" + id_string);
        }
    };

    const removeInstsAll = () => {
        console.log("removeInstsAll");
    };
    const addInstsAll = () => {};
    const emptyInstsSelected = () => {
        setSelectedInstsKept([]);
        setSelectedInsts([]);
    };
    const removeAInst = (inst: InstObject) => {
        // console.log("removeAInst", inst);
        let index = selectedInsts.findIndex(
            (p) => p.inst_id === inst.inst_id
        );
        let index_k = selectedInstsKept.findIndex(
            (p) => p.inst_id === inst.inst_id
        );
        if (index >= 0) {
            let newSelectedInsts = [...selectedInsts];
            newSelectedInsts.splice(index, 1);
            setSelectedInsts(newSelectedInsts);
        }
        if (index_k >= 0) {
            let newSelectedInstsKept = [...selectedInstsKept];
            newSelectedInstsKept.splice(index_k, 1);
            setSelectedInstsKept(newSelectedInstsKept);
        }
    };

    const AInstUnit = (props: any) => {
        let inst = props.inst;
        const [mouseOn, setMouseOn] = React.useState(false);
        return (
            <Tip
                plain
                dropProps={{ align: { bottom: "top" } }}
                content={
                    <Box background={{ color: "rgb(255,255,255,0.9)" }}>
                        <Text size="11px">제외하기</Text>
                    </Box>
                }
            >
                <Button
                    plain
                    hoverIndicator
                    margin={{ horizontal: "10px" }}
                    label={<Text size="15px">{inst.primaryname}</Text>}
                    icon={
                        <Close size="12px" color={mouseOn ? "grey" : "white"} />
                    }
                    onMouseEnter={() => {
                        setMouseOn(true);
                    }}
                    onMouseLeave={() => {
                        setMouseOn(false);
                    }}
                    onClick={() => removeAInst(inst)}
                />
            </Tip>
        );
    };

    const ResetSelect = () => (
        <Box
            width="full"
            height="full"
            align="end"
            justify="between"
            alignSelf="end"
            direction="row"
        >
            <Text size="12px" margin={{ left: "10px" }}>
                선택한 기관 {selectedInstsKept.length}명
            </Text>
            <Button
                margin={{ horizontal: "5px" }}
                plain
                label={<Text size="12px">기관 선택 초기화</Text>}
                hoverIndicator
                onClick={() => emptyInstsSelected()}
                disabled={selectedInstsKept.length === 0}
            />
        </Box>
    );
    const InstListBox = () => (
        <Box direction="row" width="full" align="center" justify="center">
            <Box
                direction="column"
                align="center"
                justify="center"
                width="full"
            >
                <ResetSelect />
                <Box
                    overflow={{ vertical: "auto" }}
                    height="full"
                    width="full"
                    border
                    style={{
                        minHeight: "80px",
                        maxHeight: "80px",
                        minWidth: "180px",
                    }}
                    round="10px"
                    margin={{ vertical: "10px" }}
                    pad={{ vertical: "10px" }}
                    direction="row"
                >
                    {selectedInstsKept.length === 0 ? (
                        <Text size="11px" margin="10px">
                            원본의 기관명 오기, 한자 폰트 등의 이유로 한 기관이
                            여러 기관명을 가질 수 있습니다. 여러 기관명으로 검색하여
                            자료를 모아보세요. 새로운 기관명으로 검색해도 선택한
                            기관은 유지됩니다. 검색의 용이성을 위해 일반명사(소학교, 보통학교, 등) 및 대표 지명(예: 경성, 부산 등)은 검색이 되지 않습니다.
                            이 경우 직원록 목차를 이용하여 검색하세요.
                        </Text>
                    ) : (
                        <Text margin={{ horizontal: "20px" }}>
                            {selectedInstsKept.map((inst: InstObject) => (
                                <AInstUnit
                                    inst={inst}
                                    key={inst.inst_id}
                                />
                            ))}
                        </Text>
                    )}
                </Box>
            </Box>
            <SelectButton />
        </Box>
    );
    const SelectButton = () => (
        <Box
            margin={{ top: "20px" }}
            direction="row"
            align="center"
            justify="center"
            style={{ minWidth: "130px", maxWidth: "200px" }}
        >
            <Box direction="row" align="center" justify="center" margin="10px">
                <ImArrowRight
                    size="20px"
                    color={selectedInstsKept.length === 0 ? "grey" : "black"}
                />
            </Box>
            <Box
                style={{
                    minHeight: "50px",
                    minWidth: "50px",
                }}
                round="10px"
                align="center"
                justify="center"
                alignSelf="center"
                onClick={() => gotoInstPage()}
                hoverIndicator={selectedInstsKept.length > 0 ? true : false}
            >
                <Button
                    onClick={() => gotoInstPage()}
                    disabled={selectedInstsKept.length === 0}
                >
                    자료보기
                </Button>
            </Box>
        </Box>
    );
    const SelectOption = () => (
        <Box
            width="full"
            direction="row"
            align="start"
            justify="start"
            flex={false}
            margin={{ top: "10px" }}
        >
            <Button
                hoverIndicator
                plain
                label={<Text size="15px">모두 선택 </Text>}
                onClick={() => {
                    addInstsAll();
                }}
                margin={{ horizontal: "5px" }}
            />
            <Text size="15px" margin={{ horizontal: "10px" }}>
                |
            </Text>
            <Button
                hoverIndicator
                plain
                label={<Text size="15px">선택 해제</Text>}
                onClick={() => {
                    removeInstsAll();
                }}
                margin={{ horizontal: "5px" }}
                disabled={selectedInsts.length === 0}
            />
        </Box>
    );

    return (
        <>
            <Box
                width="full"
                alignSelf="center"
                align="center"
                justify="center"
                direction="column"
                height="full"
            >
                <InstListBox />
                {/* <SelectOption/> */}
            </Box>
        </>
    );
};
export default InstSelectBox;
